import { useState } from 'react';

/**
 * Copiar para a área de transferência.
 *
 * O retorno visual é o ponto: sem ele, quem clica não sabe se copiou, clica de novo
 * e cola duas vezes. Falha em navegador antigo e fora de contexto seguro (a API só
 * existe em HTTPS e em localhost); nesse caso o botão diz que não conseguiu, em vez
 * de fingir que copiou — o texto seria colado vazio.
 */
export function BotaoCopiar({
  texto,
  rotulo,
  className = '',
}: {
  texto: string;
  rotulo: string;
  className?: string;
}) {
  const [estado, setEstado] = useState<'parado' | 'copiado' | 'falhou'>('parado');

  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard
          .writeText(texto)
          .then(() => setEstado('copiado'))
          .catch(() => setEstado('falhou'));
        window.setTimeout(() => setEstado('parado'), 2500);
      }}
      className={
        'shrink-0 rounded-md border px-2.5 py-1 text-xs text-[color:var(--texto)] ' +
        `transition-colors hover:border-[color:var(--acento)] hover:text-[color:var(--acento)] ${className}`
      }
    >
      {estado === 'copiado' ? 'Copiado ✓' : estado === 'falhou' ? 'Copie à mão' : rotulo}
    </button>
  );
}
